export default __webpack_public_path__ + "static/media/SF-Pro.2f9118d7.ttf";